<template>
  <v-container fill-height>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              people_alt
            </v-icon>
            <span class="title">Data Penduduk</span>
          </v-card-title>
          <v-tabs
            v-model="tabdata"
            :background-color="maincolor"
            centered
            dark
            icons-and-text
            show-arrows>
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-list">
              Penduduk
              <v-icon large>people_alt</v-icon>
            </v-tab>
            <v-tab href="#tab-addnew">
              Buat Baru
              <v-icon large>group_add</v-icon>
            </v-tab>
            <v-tab href="#tab-report">
              Laporan
              <v-icon large>assessment</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabdata">
            <v-tab-item value="tab-list">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="6" class="py-0">
                        <v-autocomplete
                          v-model="filter.kelurahan"
                          :items="listkelurahan"
                          item-value="id"
                          item-text="kelurahan"
                          label="Kelurahan"
                          return-object
                          @change="getBanjar(filter.kelurahan.id, 'load')">
                          <template v-slot:selection="data">
                            <v-chip small label class="chip-h-auto">
                              <div>
                                <strong>{{ data.item.kelurahan }}</strong> ( {{ data.item.kecamatan }}, {{ data.item.kabupaten }} )
                              </div>
                            </v-chip>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title>{{ item.kelurahan }}</v-list-item-title>
                              <v-list-item-subtitle>{{ item.kecamatan }}, {{ item.kabupaten }}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-icon>mdi-coin</v-icon>
                            </v-list-item-action>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6" class="py-0">
                        <v-autocomplete
                          v-model="filter.banjar"
                          :items="listbanjarload"
                          item-value="nama_banjar"
                          item-text="nama_banjar"
                          return-object
                          label="Banjar"
                          @change="getPenduduk">
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row justify="center" class="mb-3">
                      <v-col cols="12" md="6" class="py-0">
                        <v-select
                          :items="liststatus"
                          name="statuskerja"
                          v-model="filter.status"
                          label="Status"
                          @change="getPenduduk">
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="6" class="py-0">
                        <v-text-field
                          v-model="filter.search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row>
                      <v-col cols="12">
                        <div class="text-center" v-if="loading.getdata">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-data-table
                          :headers="headers"
                          :items="datalist"
                          :search="filter.search">
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              :to="{ name: 'PendudukdetailAdmin', query: { type: typeakun, nik: item.nik } }"
                              small
                              icon>
                              <v-icon>search</v-icon>
                            </v-btn>
                            <v-btn
                              :to="{ name: 'SuratAdmin', query: { tab: 'tab-addnew', nik: item.nik } }"
                              small
                              icon>
                              <v-icon>mail</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addnew">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="7">
                        <v-stepper v-model="e6" vertical v-show="!addstatus.success">
                          <v-stepper-step :complete="e6 > 1" step="1">Data Kartu Keluarga</v-stepper-step>
                          <v-stepper-content step="1">
                            <v-form
                              ref="step1"
                              v-model="steps.form1"
                              lazy-validation>
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="addpenduduk.no_kk"
                                    :counter="16"
                                    :rules="[rules.required, rules.nik]"
                                    label="Nomor Kartu Keluarga *"
                                    name="nokk"
                                    required
                                    @blur="checkNokk">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row v-show="hasilcheck.isshow">
                                <v-col cols="12">
                                  <v-autocomplete
                                    v-model="addpenduduk.pos"
                                    :items="listkelurahan"
                                    item-value="kelurahan"
                                    item-text="kelurahan"
                                    label="Kelurahan *"
                                    return-object
                                    :disabled="hasilcheck.already === true && hasilcheck.data[0].id_pos !== '0' && hasilcheck.data[0].id_banjar !== '0'"
                                    @change="getBanjar(addpenduduk.pos.id, 'add')"
                                    :rules="[rules.required]">
                                    <template v-slot:selection="data">
                                      <v-chip small label class="chip-h-auto">
                                        <div>
                                          <strong>{{ data.item.kelurahan }}</strong> ( {{ data.item.kecamatan }}, {{ data.item.kabupaten }} )
                                        </div>
                                      </v-chip>
                                    </template>
                                    <template v-slot:item="{ item }">
                                      <v-list-item-content>
                                        <v-list-item-title>{{ item.kelurahan }}</v-list-item-title>
                                        <v-list-item-subtitle>{{ item.kecamatan }}, {{ item.kabupaten }}</v-list-item-subtitle>
                                      </v-list-item-content>
                                      <v-list-item-action>
                                        <v-icon>mdi-coin</v-icon>
                                      </v-list-item-action>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                              <v-row v-show="hasilcheck.isshow">
                                <v-col cols="12">
                                  <v-autocomplete
                                    v-model="addpenduduk.banjar"
                                    :items="listbanjar"
                                    item-value="nama_banjar"
                                    item-text="nama_banjar"
                                    return-object
                                    label="Banjar *"
                                    :rules="[rules.required]"
                                    :disabled="hasilcheck.already === true && hasilcheck.data[0].id_banjar !== '0' && hasilcheck.data[0].id_pos !== '0'">
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                              <v-row v-show="hasilcheck.isshow">
                                <v-col cols="12">
                                  <v-textarea
                                    v-model="addpenduduk.alamat"
                                    auto-grow
                                    label="Alamat*"
                                    :rules="[rules.required]"
                                    rows="1"
                                    :disabled="hasilcheck.already === true && hasilcheck.data[0].alamat !== ''">
                                  </v-textarea>
                                </v-col>
                              </v-row>
                              <v-row v-show="hasilcheck.isshow">
                                <v-col cols="12">
                                  <v-checkbox
                                    :disabled="checkkepala"
                                    v-model="addpenduduk.kepalakeluarga"
                                    label="Sebagai kepala keluarga?">
                                  </v-checkbox>
                                </v-col>
                              </v-row>
                              <v-btn
                                color="primary"
                                large
                                :disabled="!steps.form1 || !hasilcheck.isshow"
                                @click="checkStep('step1')">
                                Berikutnya
                              </v-btn>
                            </v-form>
                          </v-stepper-content>
                          <v-stepper-step :complete="e6 > 2" step="2">Data Diri</v-stepper-step>
                          <v-stepper-content step="2">
                            <v-form
                              ref="step2"
                              v-model="steps.form2"
                              lazy-validation>
                              <v-row>
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="addpenduduk.nik"
                                    :counter="16"
                                    :rules="[rules.required, rules.nik]"
                                    label="NIK *"
                                    name="nik"
                                    required>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="addpenduduk.nama"
                                    :rules="[rules.required]"
                                    label="Nama *"
                                    name="nama"
                                    required>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="addpenduduk.tempat_lahir"
                                    label="Tempat lahir *"
                                    :rules="[rules.required]"
                                    name="tempatlahir"
                                    required>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-menu
                                    v-model="datepick.tgllahir"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px">
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        v-model="addpenduduk.tanggal_lahir"
                                        label="Tanggal lahir *"
                                        readonly
                                        :rules="[rules.required]"
                                        v-on="on">
                                      </v-text-field>
                                    </template>
                                    <v-date-picker
                                      ref="birthday"
                                      :max="datepick.date"
                                      name="tgllahir"
                                      v-model="addpenduduk.tanggal_lahir"
                                      @input="datepick.tgllahir = false">
                                    </v-date-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" md="6">
                                  <v-select
                                    :items="listkelamin"
                                    name="kelamin"
                                    v-model="addpenduduk.kelamin"
                                    label="Jenis kelamin">
                                  </v-select>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-select
                                    :items="listagama"
                                    v-model="addpenduduk.agama"
                                    name="agama"
                                    label="Agama">
                                  </v-select>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" md="6">
                                  <v-select
                                    :items="listpendidikan"
                                    name="pendidikan"
                                    v-model="addpenduduk.pendidikan"
                                    label="Pendidikan">
                                  </v-select>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-autocomplete
                                    v-model="addpenduduk.pekerjaan"
                                    :items="listpekerjaan"
                                    item-value="nama_kerja"
                                    item-text="nama_kerja"
                                    label="Pekerjaan">
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="addpenduduk.email"
                                    label="E-mail"
                                    name="email"
                                    type="email"
                                    required>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="addpenduduk.phone"
                                    label="Telephone"
                                    name="telephone"
                                    :counter="12"
                                    :rules="[rules.phone]"
                                    required>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-btn
                                v-if="!loading.adddata"
                                color="error"
                                class="mr-4"
                                large
                                @click="backStep()">
                                Kembali
                              </v-btn>
                              <v-btn
                                v-if="!loading.adddata"
                                color="primary"
                                large
                                :disabled="!steps.form2"
                                @click="submitAdd">
                                Simpan
                              </v-btn>
                              <div class="text-center" v-if="loading.adddata">
                                <v-progress-circular
                                  :width="3"
                                  color="red"
                                  indeterminate>
                                </v-progress-circular>
                              </div>
                            </v-form>
                          </v-stepper-content>
                        </v-stepper>
                        <v-alert
                          v-show="addstatus.success"
                          dense
                          text
                          :type="addstatus.data.resupdate ? 'success' : 'warning'">
                          <div v-if="addstatus.data.resupdate">
                            Selamat akun dengan NIK <strong>{{ addstatus.data.data }}</strong> berhasil dibuat.
                            Berikut tautan untuk melihat detail akun.
                            <v-btn
                              class="mx-1"
                              :to="{ name: 'PendudukdetailAdmin', query: { type: typeakun, nik: addstatus.data.data } }"
                              x-small
                              color="success"
                              dark>
                              Detail
                            </v-btn>
                            <v-btn
                              class="mx-1"
                              @click="reloadComponent"
                              x-small
                              color="primary"
                              dark>
                              Tambah Baru
                            </v-btn>
                          </div>
                          <div v-if="!addstatus.data.resupdate">
                            Selamat akun dengan NIK <strong>{{ addstatus.data.data }}</strong> berhasil dibuat, tetapi terdapat beberapa data anggota lain didalam kartu keluarga tidak terupdate.
                            Berikut tautan untuk melihat detail akun.
                            <v-btn
                              class="mx-1"
                              :to="{ name: 'PendudukdetailAdmin', query: { type: typeakun, nik: addstatus.data.data } }"
                              x-small
                              color="success"
                              dark>
                              Detail
                            </v-btn>
                            <v-btn
                              class="mx-1"
                              @click="reloadComponent"
                              x-small
                              color="primary"
                              dark>
                              Tambah Baru
                            </v-btn>
                          </div>
                        </v-alert>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-card
                          outlined>
                          <v-card-title class="title py-3">Info Kartu Keluarga</v-card-title>
                          <v-card-text class="text--primary">
                            <div class="text-center" v-if="loading.checkkk">
                              <v-progress-circular
                                :width="3"
                                color="red"
                                indeterminate>
                              </v-progress-circular>
                            </div>
                            <div v-if="hasilcheck.data.length === 0">No data available!</div>
                            <div v-if="hasilcheck.data.length > 0"><b>{{ hasilcheck.data[0].alamat }}</b></div>
                            <div v-if="hasilcheck.data.length > 0">
                              Banjar <b>{{ hasilcheck.data[0].banjar_ktp }}</b>, Kel. <b>{{ hasilcheck.data[0].kel_ktp }}</b>, Kec. <b>{{ hasilcheck.data[0].kec_ktp }}</b>, Kab.<b>{{ hasilcheck.data[0].kab_ktp }}</b>
                            </div>
                          </v-card-text>
                          <v-divider class="my-4 mx-3"></v-divider>
                          <v-card-title class="title py-3">Anggota</v-card-title>
                          <v-card-text class="text--primary">
                            <v-data-table
                              class="table-nowrap"
                              light
                              :headers="hasilcheck.headers"
                              :items="hasilcheck.data">
                            </v-data-table>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-report">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-row>
                          <v-col cols="12" class="pt-0">
                            <v-card outlined :color="maincolor" dark>
                              <v-card-title class="title py-3">Filter</v-card-title>
                              <v-divider></v-divider>
                              <v-card-text>
                                <alertsp :alertdata="alertdata"></alertsp>
                                <v-autocomplete
                                  v-model="filter.kelurahan"
                                  :items="listkelurahan"
                                  item-value="id"
                                  item-text="kelurahan"
                                  label="Kelurahan"
                                  return-object
                                  @change="getBanjar(filter.kelurahan.id, 'load')">
                                  <template v-slot:selection="data">
                                    <v-chip small label class="chip-h-auto">
                                      <div>
                                        <strong>{{ data.item.kelurahan }}</strong> ( {{ data.item.kecamatan }}, {{ data.item.kabupaten }} )
                                      </div>
                                    </v-chip>
                                  </template>
                                  <template v-slot:item="{ item }">
                                    <v-list-item-content>
                                      <v-list-item-title>{{ item.kelurahan }}</v-list-item-title>
                                      <v-list-item-subtitle>{{ item.kecamatan }}, {{ item.kabupaten }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                      <v-icon>mdi-coin</v-icon>
                                    </v-list-item-action>
                                  </template>
                                </v-autocomplete>
                                <v-autocomplete
                                  v-model="filter.banjar"
                                  :items="listbanjarload"
                                  item-value="nama_banjar"
                                  item-text="nama_banjar"
                                  return-object
                                  label="Banjar">
                                </v-autocomplete>
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-btn
                                  text
                                  :loading="loading.report"
                                  :disabled="loading.report"
                                  @click="getReport">
                                  Tampilkan
                                </v-btn>
                                <v-btn
                                  text
                                  color="yellow"
                                  :loading="loading.reportprint"
                                  :disabled="loading.reportprint"
                                  @click="downloadReport">
                                  Download
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-col>
                          <v-col cols="12">
                            <v-card
                              :color="maincolor"
                              dark
                              outlined>
                              <v-card-title class="title py-3">Penduduk Berdasar Categori Usia</v-card-title>
                              <v-card-text class="white text--primary py-3">
                                <v-data-table
                                  class="table-nowrap"
                                  light
                                  :headers="summary.usia.headers"
                                  :items="summary.usia.data"
                                  hide-default-footer>
                                </v-data-table>
                              </v-card-text>
                            </v-card>
                          </v-col>
                          <v-col cols="12">
                            <v-card
                              :color="maincolor"
                              dark
                              outlined>
                              <v-card-title class="title py-3">Penduduk Berdasar Pekerjaan</v-card-title>
                              <v-card-text class="white text--primary py-3">
                                <v-data-table
                                  class="table-nowrap"
                                  light
                                  :headers="summary.pekerjaan.headers"
                                  :items="summary.pekerjaan.data"
                                  hide-default-footer>
                                </v-data-table>
                              </v-card-text>
                            </v-card>
                          </v-col>
                          <v-col cols="12">
                            <v-card
                              :color="maincolor"
                              dark
                              outlined>
                              <v-card-title class="title py-3">Penduduk Berdasar Pendidikan</v-card-title>
                              <v-card-text class="white text--primary py-3">
                                <v-data-table
                                  class="table-nowrap"
                                  light
                                  :headers="summary.pendidikan.headers"
                                  :items="summary.pendidikan.data"
                                  hide-default-footer>
                                </v-data-table>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-row>
                          <v-col cols="4" class="pt-0">
                            <v-card
                              class="mx-auto text-center"
                              color="red"
                              dark>
                              <v-card-text>
                                <v-icon size="50" dark>house</v-icon>
                              </v-card-text>
                              <v-card-text>
                                <div class="display-1">
                                  {{ report.jumkk }}
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>
                          <v-col cols="4" class="pt-0">
                            <v-card
                              class="mx-auto text-center"
                              color="orange"
                              dark>
                              <v-card-text>
                                <v-icon size="50" dark>directions_walk</v-icon>
                              </v-card-text>
                              <v-card-text>
                                <div class="display-1">
                                  {{ report.jumlaki }}
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>
                          <v-col cols="4" class="pt-0">
                            <v-card
                              class="mx-auto text-center"
                              color="primary"
                              dark>
                              <v-card-text>
                                <v-icon size="50">pregnant_woman</v-icon>
                              </v-card-text>
                              <v-card-text>
                                <div class="display-1">
                                  {{ report.jumperempuan }}
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>
                          <v-col cols="12">
                            <v-card
                              :color="maincolor"
                              dark
                              outlined>
                              <v-card-title class="title py-3">Detail Data Penduduk</v-card-title>
                              <v-card-text class="white text--primary py-3">
                                <v-data-table
                                  light
                                  class="table-nowrap"
                                  :headers="report.headers"
                                  :items="report.data"
                                  :search="report.search">
                                  <template v-slot:[`item.lahir`]="{ item }">
                                    {{ item.tempat_lahir }}, {{ item.tanggal_lahir }}
                                  </template>
                                </v-data-table>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- modal - update -->
    <v-dialog
      v-model="dmodal.banjar"
      max-width="600px"
      v-if="dmodaldata.banjar">
      <v-card>
        <v-card-title>
          <span class="headline ma-auto">Modal</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md class="pa-0">
            Modal
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'PendudukAdmin',
  data: () => ({
    typeakun: 'user',
    e6: 1,
    steps: {
      form1: false,
      form2: false,
      form3: false,
      form4: false,
      form5: false,
    },
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      adddata: false,
      editbanjar: false,
      checkkk: false,
      report: false,
      reportprint: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    listkelamin: ['L', 'P'],
    listagama: ['Hindu', 'Budha', 'Kristen', 'Katolik', 'Islam', 'Other'],
    listpendidikan: ['SD', 'SLTP', 'SLTA', 'D1', 'D2', 'D3', 'D4', 'S1', 'S2', 'S3', 'Tidak Sekolah'],
    listpekerjaan: [],
    filter: {
      search: '',
      status: 'active',
      kelurahan: '',
      banjar: '',
    },
    report: {
      jumkk: 0,
      jumlaki: 0,
      jumperempuan: 0,
      headers: [
        { text: 'NIK', value: 'nik' },
        { text: 'KK', value: 'no_kk' },
        { text: 'Nama', value: 'nama' },
        { text: 'Lahir', value: 'lahir' },
        { text: 'Kelamin', value: 'kelamin' },
        { text: 'Agama', value: 'agama' },
        { text: 'Pendidikan', value: 'pendidikan' },
        { text: 'Pekerjaan', value: 'pekerjaan' },
      ],
      data: [],
      search: '',
    },
    summary: {
      usia: {
        headers: [
          { text: 'Usia', value: 'range_umur' },
          { text: 'Jumlah', value: 'jum' },
        ],
        data: [],
      },
      pendidikan: {
        headers: [
          { text: 'Pendidikan', value: 'pendidikan' },
          { text: 'Jumlah', value: 'jum' },
        ],
        data: [],
      },
      pekerjaan: {
        headers: [
          { text: 'Pekerjaan', value: 'pekerjaan' },
          { text: 'Jumlah', value: 'jum' },
        ],
        data: [],
      },
    },
    hasilcheck: {
      headers: [
        { text: 'NIK', value: 'nik' },
        { text: 'Nama', value: 'nama' },
        { text: 'K.Keluarga', value: 'kepalakeluarga' },
      ],
      data: [],
      already: false,
      isshow: false,
    },
    headers: [
      { text: 'NIK', value: 'nik' },
      { text: 'Nama', value: 'nama' },
      { text: 'Tgl.Lahir', value: 'tanggal_lahir' },
      { text: 'Kelamin', value: 'kelamin' },
      { text: 'Status', value: 'status' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    addpenduduk: {
      no_kk: '',
      pos: '',
      banjar: '',
      nik: '',
      nama: '',
      tempat_lahir: '',
      tanggal_lahir: '',
      kelamin: 'L',
      agama: 'Hindu',
      pendidikan: 'SLTA',
      pekerjaan: '',
      email: '',
      phone: '',
      alamat: '',
      kepalakeluarga: false,
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 8 || 'Min 8 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
      phone: (v) => v && v.length <= 12 || 'Max 12 characters',
    },
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      tgllahir: false,
    },
    tabdata: null,
    listkelurahan: [],
    listbanjar: [],
    listbanjarload: [],
    checkkepala: false,
    addstatus: {
      success: false,
      data: [],
    },
    dmodal: {
      banjar: false,
    },
    dmodaldata: {
      banjar: null,
    },
  }),
  watch: {
    'datepick.tgllahir'(val) {
      if (val) {
        setTimeout(() => (this.$refs.birthday.activePicker = 'YEAR'));
      }
    },
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    if (this.$route.query.tab && this.$route.query.tab !== '') {
      this.changeTab(this.$route.query.tab);
    }
    this.getKelurahan();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    downloadReport() {
      this.alertdata.show = false;
      if (this.tokenscr && this.filter.banjar !== '') {
        this.loading.reportprint = true;
        this.axios
          .get(
            this.api + '/api/penduduk/report/print',
            {
              params: {
                banjar: this.filter.banjar.id_banjar,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
              responseType: 'blob',
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'report-penduduk-' + this.filter.banjar.nama_banjar + '.xls');
              document.body.appendChild(link);
              link.click();
            }
            this.loading.reportprint = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.reportprint = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal server error!';
          });
      } else {
        this.alertdata.show = true;
        this.alertdata.type = 'warning';
        this.alertdata.text = 'Pilih Banjar!';
      }
    },
    getReport() {
      // console.log(this.filter.banjar);
      this.alertdata.show = false;
      if (this.tokenscr && this.filter.banjar !== '') {
        this.report.data = [];
        this.report.jumkk = 0;
        this.report.jumlaki = 0;
        this.report.jumperempuan = 0;
        this.summary.usia.data = [];
        this.summary.pendidikan.data = [];
        this.summary.pekerjaan.data = [];
        this.loading.report = true;
        this.axios
          .get(
            this.api + '/api/penduduk/report',
            {
              params: {
                banjar: this.filter.banjar.id_banjar,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.report.data = resdata.data;
                this.report.jumkk = resdata.jumkk;
                for (const row of resdata.sumkelamin) {
                  if (row.kelamin === 'L') {
                    this.report.jumlaki = row.jum;
                  } else if (row.kelamin === 'P') {
                    this.report.jumperempuan = row.jum;
                  }
                }
                this.summary.pendidikan.data = resdata.sumpendidikan;
                this.summary.pekerjaan.data = resdata.sumpekerjaan;
                this.summary.usia.data = resdata.sumusia;
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal server error!';
            }
            this.loading.report = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.report = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal server error!';
          });
      } else {
        this.alertdata.show = true;
        this.alertdata.type = 'warning';
        this.alertdata.text = 'Pilih Banjar!';
      }
    },
    changeTab(tabdata) {
      this.tabdata = tabdata;
    },
    reloadComponent() {
      const pathreturn = this.$route.path;
      const fullurl = this.baseurl + '/#' + pathreturn;
      setTimeout( () => {
        window.location.href = fullurl + '?tab=tab-addnew&t=' + (new Date()).getTime();
      }, 500);
      setTimeout( () => {
        window.location.reload(true);
      }, 1000);
    },
    getPenduduk() {
      // console.log(this.filter);
      if (this.tokenscr && this.filter.banjar !== '') {
        this.loading.getdata = true;
        this.axios
          .get(
            this.api + '/api/penduduk/',
            {
              params: {
                role: this.typeakun,
                status: this.filter.status,
                banjar: this.filter.banjar === '' ? '' : this.filter.banjar.id_banjar,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    checkStep(scope) {
      if (this.$refs[scope].validate()) {
        this.e6++;
      }
    },
    backStep() {
      this.e6--;
    },
    checkNokk() {
      this.hasilcheck.isshow = false;
      this.hasilcheck.already = false;
      this.hasilcheck.data = [];
      if (this.tokenscr && this.addpenduduk.no_kk !== '') {
        this.loading.checkkk = true;
        this.axios
          .get(
            this.api + '/api/penduduk/',
            {
              params: {
                nokk: this.addpenduduk.no_kk,
                orderby: 'kepalakeluarga',
                ordertype: 'DESC',
                role: this.typeakun,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  this.hasilcheck.already = true;
                  this.hasilcheck.data = resdata.data;
                  // data form
                  this.addpenduduk.pos = resdata.data[0].kel_ktp;
                  this.addpenduduk.banjar = resdata.data[0].banjar_ktp;
                  this.addpenduduk.alamat = resdata.data[0].alamat;
                  this.checkkepala = resdata.data[0].kepalakeluarga === 'ya' ? true : false;
                  this.getBanjar(resdata.data[0].id_pos, 'add');
                } else {
                  // data form
                  this.addpenduduk.pos = this.listkelurahan[0];
                  this.addpenduduk.banjar = '';
                  this.getBanjar(this.listkelurahan[0].id, 'add');
                  this.addpenduduk.alamat = '';
                  this.checkkepala = false;
                }
              }
            }
            this.loading.checkkk = false;
            this.hasilcheck.isshow = true;
          })
          .catch((error) => {
            console.log(error);
            this.loading.checkkk = false;
            this.hasilcheck.isshow = true;
          });
      }
    },
    getKelurahan() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/kodepos/kelurahan',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                // kelurahan
                this.listkelurahan = resdata.data;
                // for filter
                this.filter.kelurahan = this.listkelurahan[0];
                // for add data
                this.addpenduduk.pos = this.listkelurahan[0];
                // get banjar
                this.getBanjar(this.filter.kelurahan.id, 'all');
                // get pekerjaan
                this.getPekerjaan();
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    emptyBanjar(typefor) {
      if (typefor === 'load') {
        // this.datalist = [];
      } else if (typefor === 'add') {
        this.listbanjar = [];
      } else {
        // this.datalist = [];
        this.listbanjar = [];
      }
    },
    putBanjar(listdata, typefor) {
      if (typefor === 'load') {
        this.listbanjarload = listdata;
        this.filter.banjar = this.filter.banjar === '' ? listdata[0] : '';
        // get penduduk
        this.getPenduduk();
      } else if (typefor === 'add') {
        this.listbanjar = listdata;
        this.addpenduduk.banjar = this.addpenduduk.banjar === '' ? listdata[0] : this.addpenduduk.banjar;
      } else {
        this.listbanjarload = listdata;
        this.listbanjar = listdata;
        this.filter.banjar = this.filter.banjar === '' ? listdata[0] : '';
        this.addpenduduk.banjar = this.addpenduduk.banjar === '' ? listdata[0] : this.addpenduduk.banjar;
        // get penduduk
        this.getPenduduk();
      }
    },
    getBanjar(idkpos, typefor) {
      if (this.tokenscr) {
        this.emptyBanjar(typefor);
        this.axios
          .get(
            this.api + '/api/kodepos/banjarbypos',
            {
              params: {
                idpos: idkpos,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.putBanjar(resdata.data, typefor);
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getPekerjaan() {
      this.listpekerjaan = [];
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jeniskerja/',
            {
              params: {
                status: 'active',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.listpekerjaan = resdata.data;
                this.addpenduduk.pekerjaan = resdata.data[0].nama_kerja;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      this.addstatus.success = false;
      if (this.$refs.step2.validate()) {
        if (this.tokenscr) {
          this.loading.adddata = true;
          // mapping data
          const checkdata = this.hasilcheck.data;
          const datasend = {
            nik: this.addpenduduk.nik,
            no_kk: this.addpenduduk.no_kk,
            nama: this.addpenduduk.nama,
            tanggal_lahir: this.addpenduduk.tanggal_lahir,
            tempat_lahir: this.addpenduduk.tempat_lahir,
            kelamin: this.addpenduduk.kelamin,
            agama: this.addpenduduk.agama,
            pendidikan: this.addpenduduk.pendidikan,
            pekerjaan: this.addpenduduk.pekerjaan,
            alamat: this.addpenduduk.alamat,
            kab_ktp: '',
            kec_ktp: '',
            kel_ktp: '',
            pos_ktp: '',
            banjar_ktp: '',
            id_banjar: '',
            id_pos: '',
            email: this.addpenduduk.email,
            phone: this.addpenduduk.phone,
            kepalakeluarga: (this.addpenduduk.kepalakeluarga === true) ? 'ya' : 'tidak',
            role: this.typeakun,
          };
          // data pos
          if (typeof this.addpenduduk.pos === 'object') {
            datasend.id_pos = (this.addpenduduk.pos.id !== undefined) ? this.addpenduduk.pos.id : '';
            datasend.kab_ktp = (this.addpenduduk.pos.kabupaten !== undefined) ? this.addpenduduk.pos.kabupaten : '';
            datasend.kec_ktp = (this.addpenduduk.pos.kecamatan !== undefined) ? this.addpenduduk.pos.kecamatan : '';
            datasend.kel_ktp = (this.addpenduduk.pos.kelurahan !== undefined) ? this.addpenduduk.pos.kelurahan : '';
            datasend.pos_ktp = (this.addpenduduk.pos.kodepos !== undefined) ? this.addpenduduk.pos.kodepos : '';
          } else {
            datasend.id_pos = (checkdata[0].id_pos !== undefined) ? checkdata[0].id_pos : '';
            datasend.kab_ktp = (checkdata[0].kab_ktp !== undefined) ? checkdata[0].kab_ktp : '';
            datasend.kec_ktp = (checkdata[0].kec_ktp !== undefined) ? checkdata[0].kec_ktp : '';
            datasend.kel_ktp = (checkdata[0].kel_ktp !== undefined) ? checkdata[0].kel_ktp : '';
            datasend.pos_ktp = (checkdata[0].pos_ktp !== undefined) ? checkdata[0].pos_ktp : '';
          }
          // data banjar
          if (typeof this.addpenduduk.banjar === 'object') {
            const databanjar = this.addpenduduk.banjar;
            datasend.id_banjar = (databanjar.id_banjar !== undefined) ? databanjar.id_banjar : '';
            datasend.banjar_ktp = (databanjar.nama_banjar !== undefined) ? databanjar.nama_banjar : '';
          } else {
            datasend.id_banjar = (checkdata[0].id_banjar !== undefined) ? checkdata[0].id_banjar : '';
            datasend.banjar_ktp = (checkdata[0].banjar_ktp !== undefined) ? checkdata[0].banjar_ktp : '';
          }
          // console.log(datasend);
          this.axios
            .post(
              this.api + '/api/penduduk/add',
              qs.stringify(
                datasend,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.addstatus.success = true;
                  this.addstatus.data = resdata;
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.adddata = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.adddata = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'banjar') {
        this.dmodal.banjar = false;
      } else {
        this.dmodal.banjar = false;
      }
    },
    editBanjar(item) {
      this.alertupdate.show = false;
      this.dmodal.banjar = true;
      this.dmodaldata.banjar = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatekodepos.validate()) {
        if (this.tokenscr) {
          // console.log(this.dmodaldata.banjar);
          this.loading.editbanjar = true;
          this.axios
            .put(
              this.api + '/api/kodepos/banjar',
              qs.stringify(
                this.dmodaldata.banjar,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  // tslint:disable-next-line:max-line-length
                  this.alertupdate.text = this.dmodaldata.banjar.nama_banjar + '" berhasil diubah!';
                  this.getBanjar(this.dmodaldata.banjar.id, 'load');
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.editbanjar = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.editbanjar = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
